<template>
  <el-form :model="searchForm" size="mini" :inline="true" :rules="formRules">
    <el-col :span="3">
      <el-form-item prop="operatorId">
        <el-cascader  size="mini" clearable  ref="cascader"
                      :placeholder="$t('deviceControl.operatorId')" filterable
                      :options="operatorTree"
                      :props="{ checkStrictly:true,expandTrigger:'hover'}"
                      :show-all-levels="false"
                      change-on-select
                      @change='handleChangeOperator'
                      v-model="searchForm.operatorId">
        </el-cascader>
      </el-form-item>
    </el-col>
    <el-col :span="3">
      <el-form-item prop="stationCode">
        <el-select :placeholder="$t('deviceControl.stationName')" filterable v-model="searchForm.stationCode" clearable>
          <el-option v-for="item in stationsForSelect" :key="item.stationCode"
                     v-bind:label="item.stationName" v-bind:value="item.stationCode"></el-option>
        </el-select>
      </el-form-item>
    </el-col>
    <el-col :span="3">
      <el-form-item prop="appointName">
        <el-input :placeholder="$t('yu-yue-ming-cheng-0')" v-model="searchForm.appointName" clearable></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="3">
      <el-form-item prop="beginTime">
        <el-date-picker
          v-model="searchForm.beginTime"
          type="date"
          :placeholder="$t('kai-shi-shi-jian')"
          value-format="yyyyMMddHHmmss"
          :picker-options="dateOps"
          :style="{width: '100%'}">
        </el-date-picker>
      </el-form-item>
    </el-col>
    <el-col :span="3">
      <el-form-item prop="endTime">
        <el-date-picker
          v-model="searchForm.endTime"
          type="date"
          :placeholder="$t('deviceControl.EndTime')"
          value-format="yyyyMMddHHmmss"
          :picker-options="dateOps"
          :style="{width: '100%'}">
        </el-date-picker>
      </el-form-item>
    </el-col>

    <el-col :span="1.5">
      <el-form-item>
        <el-button size="mini" type="primary" @click="resetForm">{{ $t('deviceControl.empty') }}</el-button>
      </el-form-item>
    </el-col>
    <el-col :span="1.5">
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="submitForm"
                   :loading="loading">{{ $t('deviceControl.search') }}
        </el-button>
      </el-form-item>
    </el-col>
  </el-form>
</template>

<script>
  import {validateInput} from '../../../../../common/validator'

  export default {
    name: "search",
    data() {
      const validEndTime = (rule, value, callback) => {
        if (!this.searchForm.beginTime || !this.searchForm.endTime) {
          return callback()
        } else if (this.searchForm.endTime - this.searchForm.beginTime < 0) {
          return callback(this.$t('kai-shi-shi-jian-bi-xu-xiao-yu-jie-shu-shi-jian'))
        } else {
          return callback()
        }
      }
      return {
        formRules: {
          appointName: [{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,16,true,true,false,false,false,false,false)
            }, trigger: 'blur'}],
          beginTime: [{validator: validEndTime, trigger: 'change'}],
          endTime: [{validator: validEndTime, trigger: 'change'}]
        },
        dateOps: {
          shortcuts: [{
            text: this.$t('yi-ge-yue-qian'),
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', date);
            }
          }, {
            text: this.$t('yi-zhou-qian'),
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }, {
            text: this.$t('zuo-tian'),
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          }, {
            text: this.$t('jin-tian'),
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }, {
            text: this.$t('ming-tian'),
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          }, {
            text: this.$t('yi-zhou-hou'),
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }, {
            text: this.$t('yi-ge-yue-hou'),
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit('pick', date);
            }
          }]
        }
      }
    },
    props:{
      searchForm:{},
      stationsForSelect: {
        type: Array,
        required: true
      },
      operatorTree:{
        type: Array,
        required: true
      },
      loading: false,
    },
    methods: {
      resetForm() {
        for(let item in this.searchForm) {
          if(this.searchForm[item]){
            this.searchForm[item] = ''
          }
        }
        this.submitForm()
      },
      handleChangeOperator(value) {
        let operatorId = value &&value.length >0 ? value[value.length-1] : ''
        this.searchForm.operatorId= operatorId
        this.$refs.cascader.dropDownVisible = false
        this.$emit("operatorSelect", operatorId)
      },
      submitForm(){
        this.$emit("submitForm")
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/appointmentManager/appointmentSettings/search.vue